import { cn } from "cn"
import type { ReactNode } from "react"

import { Label } from "@/components/ui/label"

/**
 * A labelled form control with its validation errors. Give the control `id={id}`, and when
 * `errors` is set also `aria-invalid` and `aria-describedby={fieldErrorId(id)}`.
 */
export function Field({
  id,
  label,
  errors,
  className,
  children,
}: {
  id: string
  label: ReactNode
  errors?: string[]
  className?: string
  children: ReactNode
}) {
  return (
    <div className={cn("grid gap-2", className)}>
      <Label htmlFor={id}>{label}</Label>
      {children}
      {errors && errors.length > 0 && (
        <p id={fieldErrorId(id)} className="text-xs text-destructive">
          {errors.join(", ")}
        </p>
      )}
    </div>
  )
}

export function fieldErrorId(id: string) {
  return `${id}-error`
}
